import { type FC, useEffect } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import { trackEvent } from 'dibs-tracking';
import { NftTermsOfUseLink } from 'dibs-crypto-utils/exports/NftTermsOfUseLink.ts';
import { NftFaqLink } from './NftFaqLink.tsx';
import { useWeb3Connection } from 'dibs-crypto-utils/exports/useWeb3Connection.ts';
import { WithWalletConnectionEnsuredModalBase } from './WithWalletConnectionEnsuredModalBase.tsx';
import { type ConnectWalletContent_viewer$key } from './__generated__/ConnectWalletContent_viewer.graphql.ts';

export const ConnectWalletContent: FC<{
    trackingLabel: string;
    viewer: ConnectWalletContent_viewer$key;
}> = ({ trackingLabel, viewer: viewerRef }) => {
    const { openConnectionWithoutSigning } = useWeb3Connection();

    const viewer = useFragment(
        graphql`
            fragment ConnectWalletContent_viewer on Viewer {
                ...WithWalletConnectionEnsuredModalBase_viewer
            }
        `,
        viewerRef
    );

    useEffect(() => {
        trackEvent({
            event: 'e_ga_event',
            category: 'NFT',
            action: 'metamask connect entry',
            label: trackingLabel,
        });
    }, [trackingLabel]);

    return (
        <WithWalletConnectionEnsuredModalBase
            title={
                <FormattedMessage
                    id="nft.withWalletConnection.connectMetamask"
                    defaultMessage="Connect Your Wallet"
                />
            }
            paragraphs={[
                <FormattedMessage
                    id="nft.withWalletConnection.connectMetamask.bodyCopy1"
                    defaultMessage="In order to proceed, you will need to connect your wallet. By connecting your wallet, you agree that you have read and accepted {termsOfUse}."
                    values={{
                        termsOfUse: <NftTermsOfUseLink />,
                    }}
                />,
            ]}
            showWalletButtons
            footer={<NftFaqLink />}
            onMetamaskConnect={() => {
                return openConnectionWithoutSigning(() => {
                    trackEvent({
                        event: 'e_ga_event',
                        category: 'NFT',
                        action: 'metamask connect complete',
                        label: 'CONNECT_METAMASK',
                    });
                });
            }}
            viewer={viewer}
        />
    );
};
